import { type FC } from "react";
import { ArrowLeftRight } from "lucide-react";

export const ActivityEmptyState: FC = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-16">
      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-background">
        <ArrowLeftRight className="h-4 w-4 rotate-90 text-secondary" aria-hidden="true" />
      </div>
      <p className="text-sm font-semibold text-center">No transactions yet</p>
      <p className="text-sm text-secondary text-center max-w-[400px]">
        Deposits and payments appear here within a day of clearing. We&apos;ll sort each one into a
        category for the final accounting.
      </p>
    </div>
  );
};
